import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TrackerRoutingModule } from './tracker-routing.module';
import { ListComponent } from './list/list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatMenuModule } from '@angular/material/menu';
import { QuillModule } from 'ngx-quill';
import { NewTrackerComponent } from './new-tracker/new-tracker.component';


@NgModule({
  declarations: [
    ListComponent,
    NewTrackerComponent
  ],
  imports: [
    CommonModule,
    TrackerRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    NgxSpinnerModule,
    PipeModule,
    NgbModule,
    NgSelectModule,
    MatMenuModule,
    QuillModule.forRoot(),

  ]
})
export class TrackerModule { }
